import script from "./KbdGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./KbdGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__